import React from "react";
import { default as MuiCardContent } from "@mui/material/CardContent";

function CardContent(props) {
  return <MuiCardContent {...props} />;
}

export default CardContent;
